import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import useQueryParams from 'utils/hooks/useQueryParams'
import { ROUTES } from 'constants/routes'
import { notificationShow } from 'modules/Notifications/actions'
import YANDEX_API_V1 from 'api/yandex/v1'

const YandexAdsCode = () => {
  const dispatch = useDispatch()
  const { query: { code } = {} } = useQueryParams()
  const pathGen = useGeneratePathI18n()

  useEffect(() => {
    YANDEX_API_V1.sendUsers({
      data: { code },
    })
      .then(({ response, error }) => {
        if (error) {
          throw error
        } else {
          if (!global.opener || typeof global.opener.getBack === 'undefined') {
            global.location.assign(pathGen(ROUTES.SERVICES))
            return
          }

          global.opener.getBack(response.data)

          global.close()
        }
      })
      .catch((error) => {
        const { errors = [] } = error

        if (errors.length) {
          errors.forEach((error = {}) => {
            Object.values(error).forEach((v) => {
              dispatch(
                notificationShow({
                  type: 'error',
                  message: v,
                }),
              )
            })
          })
        } else {
          dispatch(
            notificationShow({
              type: 'error',
              message: 'common::notifications.unexpected_error',
            }),
          )
        }

        console.logXHR(error)
      })
  }, [])

  return null
}

export default YandexAdsCode
